// react
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

// custom components
import OrderStatus from './components/order-status';
import MarketplaceFooter from './components/marketplace-footer';
import CheckoutPricing from './components/checkout-pricing';

// bootstrap
import Button from 'react-bootstrap/Button';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectUserSavedTransaction } from 'redux/slices/marketplace/user-transaction';
import { resetShoppingCart, setManuallySet, selectTableNumber } from '_redux/slices/marketplace/user-marketplace';
import { selectOneRetailer } from '_redux/slices/marketplace/retailer';

// icons
import { MdCheckCircleOutline } from 'react-icons/md';

// styles
import { Spacing, Colors } from '_styles';
import RetailerTitle from './components/retailer-title';

// moment
const moment = require('moment');

const OrderCompletePage = (props) => {

    //#region states
    const history = useHistory();

    // redux
    const dispatch = useDispatch();
    const userTransaction = useSelector(selectUserSavedTransaction);
    const tableNumber = useSelector(selectTableNumber);
    const retailer = useSelector(selectOneRetailer);

    // local states
    const [dateSold, setDateSold] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    //#endregion

    //#region useEffects
    useEffect(() => {
        // dispatch(resetShoppingCart());
    }, []);

    // set transaction sale date
    useEffect(() => {
        let timestamp = userTransaction?.transactionData?.timestamp;
        let formattedDate = moment.unix(timestamp).utc().format('ddd, DD MMM YYYY hh:mmA');
        setDateSold(formattedDate);
    }, []);
    //#endregion


    //#region functions
    const navigateToRetailer = (retailerId, tableNumber) => {
        history.push(`/retailer-products/${retailerId}?tableNumber=${tableNumber}`);
    };

    const handleOrderComplete = () => {
        dispatch(setManuallySet(false)); 
        navigateToRetailer(retailer?.id, tableNumber);
    }
    //#endregion

    const handleLogoClick = () => {
        // go to retailer products page
        navigateToRetailer(retailer?.id, tableNumber);
    }

    return (
        <div style={styles.pageContainer}>
            <div style={styles.contentContainer}>

                {/* retailer title */}
                <RetailerTitle retailer={retailer} handleLogoClick={handleLogoClick} hideCart={true} />

                {/* order summary */}
                <OrderStatus setTotalPrice={setTotalPrice} />

            </div>

            {/* total footer */}
            <div style={styles.purchaseContainer}>

                <CheckoutPricing />

                {/* <Button style={styles.button} variant="primary" onClick={handleOrderComplete}>Order Complete</Button> */}

            </div>

            <MarketplaceFooter />
        </div>
    );
};

export default OrderCompletePage;

const styles = {
    pageContainer: {
        display: 'flex',
        flexDirection: 'column',
        //minHeight: '100vh',
    },
    contentContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    successMessageContainer: {
        padding: Spacing.SCALE_20,
        marginBottom: Spacing.SCALE_12,
        borderRadius: 8,
        elevation: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
    successMessageText: {
        fontSize: 24,
        fontWeight: 'bold',
        color: Colors.PRM_GREEN,
        margin: 0,
    },
    orderIdText: {
        fontSize: 16,
        fontWeight: '600',
        color: Colors.GRAY,
        margin: 0,
    },
    orderDateText: {
        fontSize: 14,
        color: Colors.GRAY,
        margin: 0,
    },
    purchaseContainer: {
        backgroundColor: '#F0F0F0',
        borderTop: `1px solid ${Colors.GRAY_LIGHT}`,
        padding: `${Spacing.SCALE_16}px ${Spacing.SCALE_20}px`,
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    label: {
        fontSize: 16,
        fontWeight: 600,
        color: '#333',
    },
    labelValue: {
        fontWeight: 'normal',
        marginLeft: 4,
        color: '#333',
    },
    button: {
        minWidth: '100%',
        padding: `${Spacing.SCALE_10}px ${Spacing.SCALE_20}px`,
        fontWeight: 'bold',
    },
};
